
import { computed, DestroyRef, inject, Signal, model, signal, HostListener, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { AppMenuitemComponent } from './app.menuitem.component';
import { TooltipModule } from 'primeng/tooltip';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@lib/auth/data-access';
import { VersionService } from '@lib/shared/data-access';
import { AccordionModule } from 'primeng/accordion';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    standalone: true,
    imports: [
    FormsModule,
    DialogModule,
    AppMenuitemComponent,
    TooltipModule,
    RouterModule,
    AccordionModule
]
})
export class AppMenuComponent implements OnInit {
    @HostListener('window:resize')
    onResize() {
        // Call sidebarItemsComputed whenever the window is resized
        this.dummySignal.set(!this.dummySignal());
    }

    private dummySignal = signal<boolean>(false);
    public isBottomMenuItem = model.required<boolean>();
    public router = inject(Router);
    public destroyRef = inject(DestroyRef);
    public authService = inject(AuthService);
    public versionService = inject(VersionService);
    public isSuperAdminScreen = model.required<boolean>();

    public visible: boolean = false;

    public sidebarItemsComputed: Signal<MenuItem[]> = computed(() => {
        //This is not my prouddest moment, but I had to do it to get the menu to update when the window is resized
        this.dummySignal();

        if (this.isBottomMenuItem()) {
            return [
                {
                    label: 'About',
                    icon: 'fa-regular fa-info',
                    items: window.innerWidth > 991 ? undefined : [
                        {
                            label: 'About',
                            icon: 'fa-regular fa-info',
                            command: () => {
                                this.showDialog();
                            }
                        }
                    ],
                    command: () => {
                        this.showDialog();
                    }
                },
            ];
        }
        if (this.isSuperAdminScreen()) {
            return [
                    {                    
                        label: 'Administration',
                        icon: 'pi pi-th-large',
                        items: [
                            {
                                label: 'Feature Toggles',
                                icon: 'pi-fw fa-solid fa-toggle-on fa-lg',
                                routerLink: ['/super-admin/administration/feature-toggle']
                            },
                            {
                                label: 'License',
                                icon: 'pi-fw fa-solid fa-file-certificate',
                                routerLink: ['/super-admin/administration/licenses']
                            },
                            {
                                label: 'Redis Cache Management',
                                icon: 'pi-fw fa-solid fa-database',
                                routerLink: ['/super-admin/administration/redis-management']
                            },
                            {
                                label: 'Admin User Filters',
                                icon: 'pi-fw fa-solid fa-users-cog',
                                routerLink: ['/super-admin/administration/admin-user-filters']
                            }
                        ]
                    },
                    {                    
                        label: 'Integrations',
                        icon: 'pi-fw fa-solid fa-arrows-turn-to-dots',
                        items: [
                            {
                                label: 'OnPrem File Mover',
                                icon: 'pi-fw fa-solid fa-computer',
                                routerLink: ['/super-admin/integrations/onprem-filemover']
                            },
                            {
                                label: 'Secure File Mover',
                                icon: 'pi-fw fa-solid fa-cloud',
                                routerLink: ['/super-admin/integrations/secure-file-mover']
                            },
                            {
                                label: 'Integration Processing Logs',
                                icon: 'pi-fw fa-solid fa-history',
                                routerLink: ['/super-admin/integrations/logs']
                            },
                        ]
                    }
                ]
        }
        return [
            {
                label: 'Users',
                icon: 'fa-regular fa-users text-xl text-primary',
                routerLink: ['/administration-center/users'],
                visible: !this.authService.isUnauthorizedComputedSignal()
            },
            {
                label: 'Roles',
                icon: 'fa-duotone fa-solid fa-rectangles-mixed',
                routerLink: ['/administration-center/roles'],
                visible: !this.authService.isUnauthorizedComputedSignal()
            },
            {
                label: 'Audit',
                icon: 'fa-duotone fa-solid fa-book-user',
                routerLink: ['/administration-center/audit'],
                visible: !this.authService.isUnauthorizedComputedSignal()
            },
        ];
    })

    ngOnInit(): void {
        this.versionService.fetchVersions();
    }

    showDialog() {
        this.visible = true;
    }
}